$(document).ready(function() {
	if(!document.getElementById('resultProductList')) return false;
	var productType = ($('#resultProductList .cardlist-box').length > 0) ? 'card' : 'default';

	// PJTQUICKWIN - 20220225 
	var cheangStatusModelGroup = function($obj) {

		// Search result 에는 원래 해당 소스가 없었음.
		if(productType == 'card') {
			var _this = $obj;
			var obj_ea = _this.find('a').length;
			var group_width = _this.width();
			var obj_width = _this.find('a').outerWidth(true);
			var obj_etc = (obj_ea - 1) * 4; // LGETW-256 : margin 값 계산 수정

			_this.find('.btn-limited').remove();
			_this.removeClass('limited');
			_this.find('.under2').removeClass('under2');

			if(obj_ea * obj_width  > group_width){
				_this.addClass('limited');

				var countItemViewport = 0;
				var firstItemOffsetTop = _this.find('a').eq(0).offset().top;
				for(var i=0;i<obj_ea;i++) {
					if(_this.find('a').eq(i).offset().top == firstItemOffsetTop) {
						countItemViewport ++;
					}
				}

				if(obj_ea - countItemViewport == 0) {
					_this.removeClass('limited');
					_this.find('.btn-limited').remove();
				}

				for(var j=0;j<obj_ea;j++) {
					if(j > countItemViewport-1) {
						_this.find('a').eq(j).addClass('under2');
					}
				}

				if(!_this.find('button').hasClass('btn-limited')){
					_this.append('<button class="btn-limited">'+ '+ ' + (obj_ea-countItemViewport) + '</button>')
					_this.find('button').on('click', function(e){
						if ($(window).width() < 768){
							_this.toggleClass('open');
							if(_this.hasClass('open')){
								$('.model-group').removeClass('open')
								_this.addClass('open');
							} else{
								_this.removeClass('open');
							}
						}
					});
				} else {
					_this.find('.btn-limited').text('+' + (obj_ea-countItemViewport));
				}
			} else{
				_this.removeClass('limited');
				_this.find('.btn-limited').remove();
			}
		}
	}

	// filter box function
	var filter = {
		el: document.getElementById('categoryFilterForm'),
		result: document.getElementById('resultAppendTarget'),
		btnReset :document.querySelector('button[type=reset]'),
		template: null,
		pageTemplate: null,
		memberTemplate: null,
		initial: null,
		textMore : null,
		textLess : null,
		textOpen : null,
		dragbarVal : {},
		countObj: $('.search-tab-wrap .tabs-type-liner li').find('.btn-tab.active > span'),
		countAll: 0,
		addToCartOnly : false,
		guestPriceMessage : '',			//	LGCOMPA-44 add
		guestPriceMessageUseFlag : '',	//	LGCOMPA-44 add
		obsWelcomePriceTemplate: null,	//LGCOMITF-69
		// filter box folding script
		ui: {
			el: {
				open: document.querySelector('.filter-open-box'),
				close: document.querySelector('.filter-result'),
				fieldset: null
			},
			init: function(){
				var _this = filter.ui.el;
				_this.fieldset = filter.el.querySelectorAll('fieldset'),
				_this.optionList = $(_this.fieldset).find('.option-list');
				
				$(_this.open).off().on({
					click: function(e){
						e.preventDefault();
						console.log( $(filter).el );
						if(!$(filter.el).is(':visible')){ 
							$(filter.el).addClass('open'); 
							$(this).hide();
							$(_this.close).find('a').focus();
						}else{ 
							$(filter.el).hide();
						}
					}
				});
				$(_this.close).off().on({
					click: function(e){
						e.preventDefault();
						var state = $(filter.el).css('display');
						if($(filter.el).is(':visible')){ 
							$(filter.el).removeClass('open'); 
							$(_this.open).show();
							$(_this.open).find('a').focus();
						}
					}
				});
				// fieldset folding script
				$(_this.fieldset).off().on({
					click: function(e){	
						e.preventDefault();
						var parent_box = e.delegateTarget;
						if ($(parent_box).is(".open")){
							$(parent_box).removeClass("open").addClass("close");
							$(e.currentTarget).attr('aria-expanded', false);
						} else {
							$(parent_box).removeClass("close").addClass("open");
							$(e.currentTarget).attr('aria-expanded', true);
						}
						$(this).toggleClass('active');
						$(this).parent().next().toggle();
					}
				}, '.btn-list');

				// fieldset count more/less script
				$.each(_this.optionList, function(){
					var idx = 0;
					$.each($(this).children('ul').children('li'),function(){
						if($(this).is(':visible')){
							idx++
						};
					});
					// if(idx > 5){
					// 	$(this).children('ul').children('li').eq(4).nextAll().hide();
					// 	$(this).next('.btn-list-toggle').addClass('expose');
					// } else {
						if(!$(this).hasClass('primary-list')){
							$(this).children('ul').children('li').show();
						}
						// $(this).next('.btn-list-toggle').removeClass('expose');
					// };
				});
				// fieldset folding script
				// $(_this.fieldset).on({
				// 	click: function(e){	
				// 		e.preventDefault();
				// 		if($(this).hasClass('btn-more')){
				// 			$(this).closest('.option-box').find('li').show();
				// 		} else {
				// 			$(this).closest('.option-box').find('li').eq(4).nextAll().hide();
				// 		}
				// 		$(this).parent().find('button').toggleClass('active');
				// 	}
				// }, '.btn-list-toggle button');
			}
		},
		// jquery ui slider field function
		slider: {
			el: null,
			value: null, // Array inputed in filter markup
			init: function(){
				var _this = filter.slider;
				_this.value = filter.dragbarVal;
				_this.el = filter.el.querySelectorAll('.slider-wrap');
				
				for (var i = 0; i < _this.el.length; i++) {
					var __this = _this.el[i];
					var range = __this.querySelector('.slider-range'),
						matchArray = _this.value[__this.getAttribute('data-value')],
						max = matchArray.length-1;

					$(range).data('matchArray', matchArray)
						.slider({
							range: true,
							min: 0,
							max: max,
							values: [0, max],
							slide: _this.slide,
							change: _this.change,
						}).data("ui-slider")._slide();

					$(range).find('.ui-slider-handle').eq(0).attr('aria-label', range.getAttribute('data-min'));
					$(range).find('.ui-slider-handle').eq(1).attr('aria-label', range.getAttribute('data-max'));
				}
			},
			slide: function( event, ui ) {
				// 20200311 START 박지영 Slider에서 같은 값 선택 가능하도록 수정
				// if(ui.values[0] == ui.values[1]) return false;
				// 20200311 END

				// 20200406 START 박지영 : 둘다 Min 혹은 둘다 Max를 선택할 수 없도록 수정
				var num = $(this).data('matchArray').length - 1;
				if(ui.values[0]==0 && ui.values[1] == 0) return false;
				if(ui.values[0]==num && ui.values[1] == num) return false;
				// 20200406 END

				// 20200311 START 박지영 Slider에 aria-valuemin, aria-valuemax, aria-valuenow 추가
				var $wrap = $(this).parents('.slider-wrap'),
					_matchArray = $(this).data('matchArray'),
					minKey = Object.keys(_matchArray[ui.values[0]]),
					maxKey = Object.keys(_matchArray[ui.values[1]]),
					min = Object.keys(_matchArray[1]),
					max = Object.keys(_matchArray[_matchArray.length-2]);

				var box = {
					$min: $wrap.find('.min-box'),
					$max: $wrap.find('.max-box')
				};

				var dragbarValueArray = filter.returnBetweenValue(_matchArray, ui.values[0], ui.values[1]+1);

				box.$min.find('span').text(minKey);
				box.$max.find('span').text(maxKey);
				$wrap.find('.ui-slider-handle').eq(0).attr('aria-valuetext',minKey).attr('aria-valuemin', min).attr('aria-valuemax', max).attr('aria-valuenow', minKey);
				$wrap.find('.ui-slider-handle').eq(1).attr('aria-valuetext',maxKey).attr('aria-valuemin', min).attr('aria-valuemax', max).attr('aria-valuenow', maxKey);
				// 20200311 END
				box.$min.find('input').val(_matchArray[ui.values[0]][minKey]);
				box.$max.find('input').val(_matchArray[ui.values[1]][maxKey]);

				// remove first ','  and last ','
				dragbarValueArray = dragbarValueArray.replace(/^\,|\,$/g, '');

				$wrap.find('input[name='+$wrap.attr('data-value')+']').val(dragbarValueArray);
			},
			change: function(event, ui){
				$(this).trigger('change', [ui]);
			},
			setSlider: function(){
				var _this = filter.slider;
				if($(_this.el).is('div')) {
					for (var i = 0; i < _this.el.length; i++) {
						var __this = _this.el[i],
							__range = $(__this).find('.slider-range');

						var valueIndex = {
							min: $(__this).find('.min-box input').data('index'),
							max: $(__this).find('.max-box input').data('index')
						};
						valueIndex = {
							min: valueIndex.min ? valueIndex.min : 0,
							max: valueIndex.max ? valueIndex.max : $(__range).slider("option", "max")
						};
						$(__this).find('.slider-range')
							.slider('values', [valueIndex.min, valueIndex.max]).data("ui-slider")._slide();
					}
				}
			},
			indexOfValue: function(arr, val){
				for (var i = 0; i < arr.length; i++) {
					var _obj = arr[i];
					for(var key in _obj) {
						if(_obj[key] == val) {
							return i;
						}
					}
				}
			}
		},
		filterLayer : function() {
			const layer = $(".result-filter-area");
			$('.btn-filter').on("click",function(){
				layer.addClass("active");
				$("body").addClass("modal-open");
			});
			$('.btn-result-show, .result-filter-area .btn-close').on("click",function(){
				layer.removeClass("active");
				$("body").removeClass("modal-open");
			});
		},
		init: function(){
			filter.initial = $(filter.el).serialize();
			filter.template = $('#productTemplate').clone().html();
			filter.pageTemplate = $('#paginationTemplate').clone().html();
			filter.memberTemplate = $('.product-member-price').clone().html();
			filter.obsWelcomePriceTemplate = $('.obs-welcome-price-template').clone().html(); //LGCOMITF-69
			$('#productTemplate').remove();
			$('#paginationTemplate').remove();

			if($('.search-wrap').data('mobile') === 'Y') isMobile = true;

			// 탭에서 전체 갯수 가져오기
			filter.countAll = filter.countObj.text();

			filter.ui.init(); // mobile ui events setting

			filter.filterLayer();

			if(typeof filter.el.length == "object") {
				var itemLength;
				if(isMobile) {
					itemLength = filter.el.length.getAttribute('data-mobile');
				}else {
					itemLength = filter.el.length.getAttribute('data-desktop');
				}
				filter.el.length.value = itemLength;
			}
			filter.addEvent();
			
			filter.guestPriceMessage		= '';	//	LGCOMPA-44 add
			filter.guestPriceMessageUseFlag	= '';	//	LGCOMPA-44 add

			// 로딩시, etc-box의 버튼들 disabled 
			$(filter.el).find('.etc-box').find('button').prop('disabled', true);
		},
		// filter clear button click
		activateInput: function(enableList){

			if(typeof enableList === 'undefined') return false;
			var _enableList = enableList;
			var form = filter.el;

			var $labels = $(form).find('label');
			if(_enableList != '') {
				$(form).find('fieldset.dynamic').removeClass('disabled').find('li').addClass('disabled').find('input').attr('disabled', 'disabled');
				for (var i = 0; i < _enableList.length; i++) {
					var keyId = _enableList[i].facetValueId;
					var _$faceInput = $(form).find('input[value="'+keyId+'"]'),
					_$faceLabel = _$faceInput.parents('label');
					//_$faceLabel.find('.filter-option-count').text('('+_enableList[i].modelCount+')');
					_$faceInput.removeAttr('disabled');
					_$faceLabel.closest('li').removeClass('disabled');
					/*
					if( _enableList[i].enable.toUpperCase() == "N"){
						_$faceInput.attr('disabled', 'disabled');
						_$faceLabel.closest('li').addClass('disabled');
					}else {
						_$faceInput.removeAttr('disabled');
						_$faceLabel.closest('li').removeClass('disabled');
					}
					*/
				}
				$(form).find('fieldset.dynamic').each(function() {
					if($(this).find('.option-list ul').length>0) {
						if($(this).find('.option-list ul li').length == $(this).find('.option-list ul li.disabled').length) {
							$(this).addClass('disabled');
						}
					}
				});
			}
		},
		createProductItem: function(productList, productMessages){ // 여기
			var html = [];
			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
					template = filter.template;
				
				//LGEDE-907 Start
				var productTag1Str = '';
				var productTag2Str = '';
				if('Y' == p.obsComTagShowFlag) {
					if('OBS' == p.productTag1Type) {
						if(null != p.productTag1 && '' != p.productTag1) {
							productTag1Str = p.productTag1;
						}
					} else if('COM' == p.productTag1Type) {
						if(null != p.productTag1 && '' != p.productTag1) {
							productTag1Str = p.productTag1;
						}
					}
					
					if('OBS' == p.productTag2Type) {
						if(null != p.productTag2 && '' != p.productTag2) {
							productTag2Str = p.productTag2;
						}
					} else if('COM' == p.productTag2Type) {
						if(null != p.productTag2 && '' != p.productTag2) {
							productTag2Str = p.productTag2;
						}
					}
						
				} else {
					productTag1Str = p.productTag1;
					productTag2Str = p.productTag2;
				}
				//LGEDE-907 End
				
				// LGCOMPL-46 Start
				var currencyPosition = $('input[name=currencyPosition]').val()
				var currencySymbol = $('input[name=currencySymbol]').val()
				var obsConvertSubscriptionMonthlyCostArea = '';
				var obsConvertSubscriptionMonthlyCost = changeFormatFullPrice(p.obsConvertSubscriptionMonthlyCost, p.obsConvertSubscriptionMonthlyCostCent)
				if(p.obsConvertSubscriptionMonthlyCost != null && obsConvertSubscriptionMonthlyCost != '0') {
					if(currencyPosition != null) {
						obsConvertSubscriptionMonthlyCostArea = currencyPosition == 'R' ? obsConvertSubscriptionMonthlyCost + "" + currencySymbol
															:	currencyPosition == 'L' ? currencySymbol + "" + obsConvertSubscriptionMonthlyCost
															: '';
						}
				}
				// LGCOMPL-46 End
				
				template = template.replace(/\*modelId\*/g, p.modelId)
								.replace(/\*modelName\*/g, p.modelName)
								.replace(/\*modelName_toLowerCase\*/g, p.modelName.toLowerCase())
								.replace(/\*imageAltText\*/g, (p.imageAltText != null) ? p.imageAltText : '')
								// 20200325 START 박지영 - ufn 따옴표 처리
								.replace(/\*userFriendlyName\*/g, p.userFriendlyName == null ? '' : p.userFriendlyName.replace(/\"/g, "''"))
								// 20200325 END
								.replace(/\*salesModelCode\*/g, p.salesModelCode)
								.replace(/\*modelUrlPath\*/g, p.modelUrlPath)
								.replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
								.replace(/\*smallImageAddr\*/g, p.smallImageAddr)
								.replace(/\*productTag1\*/g, productTag1Str) //LGEDE-907
								.replace(/\*productTag2\*/g, productTag2Str) //LGEDE-907
								.replace(/\*productTag3\*/g, p.productTag3)
								.replace(/\*whereToBuyUrl\*/g, p.whereToBuyUrl)
								.replace(/\*inquiryToBuyUrl\*/g, p.inquiryToBuyUrl)
								.replace(/\*findTheDealerUrl\*/g, p.findTheDealerUrl)
								.replace(/\*promotionText\*/g, p.promotionText ? p.promotionText : "")
								// PJTOBS 20200703 Start 
								.replace(/\*reStockAlertUrl\*/g, p.reStockAlertUrl ? p.reStockAlertUrl : "")
								// PJTOBS 20200703 End
								/* LGEUS-12083 : 20190826 add */
								.replace(/\*rDiscountedPrice\*/g, p.rDiscountedPrice ? changeFormatPrice(p.rDiscountedPrice) : 'null')
								.replace(/\*rDiscountedPriceCent\*/g, p.rDiscountedPriceCent)
								/* //LGEUS-12083 : 20190826 add */
								/* in-house review rating add */
								.replace(/\*sRating2\*/g, p.sRating2)
								.replace(/\*pCount\*/g, p.pCount)
								.replace(/\*ratingPercent\*/g, p.ratingPercent)
								/* // in-house review rating add */
								.replace(/\*siblingType\*/g, p.siblingType)
								.replace(/\*discountedRate\*/g, p.discountedRate)
								.replace(/\*retailerPricingText\*/g, p.retailerPricingText)
								.replace(/\*salesSuffixCode\*/g, (p.salesSuffixCode || ''))
								.replace(/\*modelYear\*/g, (nvl(p.modelYear,'') || '')) /* LGEGMC-1279 : 2021.03.12 add */
								.replace(/\*dataOrder\*/g, i+1) /* LGEGMC-1430 */
								.replace(/\*buName1\*/g, p.buName1)
								.replace(/\*buName2\*/g, p.buName2)
								.replace(/\*buName3\*/g, nvl(p.buName3,''))/* LGEGMC-712 add */
								.replace(/\*isHasMember\*/g, (p.membershipDisplayFlag=="Y")?'has-member':'')
								.replace(/\*isHasLowPrice\*/g, (p.obsLowestPriceFlag=="Y" && !!p.rPromoPrice) ? 'has-lowPrice' : '') // LGECZ-429, LGCOMPL-216
								.replace(/\*superCategoryName\*/g, p.superCategoryName)
								.replace(/\*priceValue\*/g, (nvl(p.rPrice,'')+'.'+nvl(p.rPriceCent,'00') || ''))/* LGEGMC-712 add */
								.replace(/\*emiMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')/* PJTOBSEMI-1-v2 add */
								.replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;') /* LGEAU-378 add */
								.replace(/\*wtbClass\*/g, (p.wtbExternalLinkUseFlag =="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') ? 'in-buynow' : 'where-to-buy') //LGEGMC-2202
								.replace(/\*obsPartnerUrl\*/g, nvl(p.obsPartnerUrl, '')) //LGEEG-154
								.replace(/\*emiPopupUrl\*/g, p.obsEmiMsgFlag == 'Y' ? p.emiPopupUrl : '')/* LGEGMC-3167 add */
								.replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEGMC-3167 add, OBSLGEAU-749 (5000 -> 10000) */
								.replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')/* LGEGMC-3167 add */
								.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode) //LGEDE-672
								// LGCOMPL-46 Start
								.replace(/\*obsSubscriptionLandingPageUrl\*/g, p.obsSubscriptionLandingPageUrl != null ? p.obsSubscriptionLandingPageUrl : '')
								.replace(/\*obsSubscriptionCtaLinkTarget\*/g, p.obsSubscriptionCtaLinkTarget != null ? p.obsSubscriptionCtaLinkTarget : '')
								.replace(/\*obsSubscriptionDisclaimer\*/g, p.obsSubscriptionDisclaimer != null ? p.obsSubscriptionDisclaimer : '')
								.replace(/\*obsConvertSubscriptionMonthlyCostArea\*/g, obsConvertSubscriptionMonthlyCostArea != '' ? obsConvertSubscriptionMonthlyCostArea : '')
								.replace(/\*obsSubscriptionMaxMonth\*/g, p.obsSubscriptionMaxMonth != null ? p.obsSubscriptionMaxMonth : '')
								// LGCOMPL-46 End
								;
				//LGCOMMON-12724 Start
				//LGCOMMON-7821 Start
				var epsPictoFlag = p.epsPictoFlag;
				var includeChargerYn = p.includeChargerYn  == 'Y' ? '' : 'not-included';
				var usbPdYn = p.usbPdYn == 'Y' ? 'USB PD' : '';
				var minPower = p.minPower;
				var maxPower = p.maxPower;
				var epsPictogramHtml = "";
				
				if(epsPictoFlag == "Y"){
					epsPictogramHtml += '<div class="c-charging-device">';
					epsPictogramHtml += '<div class="c-info-charging">';
					epsPictogramHtml += '<i class="c-info-charging__icon ' + includeChargerYn + '" aria-hidden="true">';
					epsPictogramHtml += '<span class="c-info-charging__alt">';
					epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
					epsPictogramHtml += '</span>';
					epsPictogramHtml += '</i>';
					epsPictogramHtml += '<div class="c-info-charging__text">';
					epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
					epsPictogramHtml += '</div>';
					epsPictogramHtml += '</div>';
					epsPictogramHtml += '</div>';
				}
				template = template.replace(/\*epsPictogramArea\*/g, epsPictogramHtml);
				//LGCOMMON-7821 End
				//LGCOMMON-12724 End
				 //LGEGMC-383
				var pdfDownloadFile = $("#pdfDownloadFile").val();
				var productFicheDownload = $("#productFicheDownload").val();
				//LGESR-72
				var rsProductFicheDownload = $("#rsProductFicheDownload").val();
				var rsUseFlag = p.rsUseFlag;
				if(rsUseFlag == "Y"){
					productFicheDownload = rsProductFicheDownload;
				}
				//LGESR-72
				//LGEGMC-5315
				var docTypeCodeFlag = p.docTypeCodeFlag;
				if(docTypeCodeFlag == "N" || ((docTypeCodeFlag == "N" || docTypeCodeFlag == "O") && p.washTowerFlag=="Y")){
					var productFicheDownload = $("#productNewFicheDownload").val();
				}else if(docTypeCodeFlag == "O"){
					var productFicheDownload = $("#productOldFicheDownload").val();
				}
				//LGEGMC-5315
				var productFichehtml ='';
			   	//LGEGMC-3921
            	if(p.washTowerFlag=="Y"){
            		if( p.productFicheFileName !="" && p.productFicheOriginalName !="" && p.productFicheFileName != null && p.productFicheOriginalName !=null && p.productFicheDocId !=null && p.productFicheDocId !="" && p.secondProductFicheFileName !="" && p.secondProductFicheOriginalName !="" && p.secondProductFicheFileName != null && p.secondProductFicheOriginalName !=null && p.secondProductFicheDocId !=null && p.secondProductFicheDocId !=""){
            			productFichehtml += "<div class='energy-label-wrap'><a href='#' adobe-click='pdp-file-down-click' data-doc='"+ p.productFicheDocId +  "' data-file='" + p.productFicheFileName + "' data-original='" + p.productFicheOriginalName + "' data-category='' class='link-text text-tooltip' title='" + pdfDownloadFile + "'>"
            			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
            			+ "</a>"+ "<div class='tooltip-link'><div class='tolltip-inner'>";
            			productFichehtml += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+p.productFicheDocId+ "' data-sku= '" + p.modelName + "' data-model-id= '" + p.modelId  +"'  data-file='"+p.productFicheFileName+"' data-original='"+p.productFicheOriginalName+"' data-category='' class='link-text link-text-uk' title='" + pdfDownloadFile +"("+p.productFicheproductLeve1Code+")"+ "'>"+p.productFicheproductLeve1Code+"</a>";
						productFichehtml += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + p.secondProductFicheDocId + "' data-file='" + p.secondProductFicheFileName + "' data-original='" + p.secondProductFicheOriginalName + "'  data-category='' class='link-text link-text-eu' title='" + pdfDownloadFile +"("+p.secondProductFicheproductLeve1Code+")"+ "'>"+p.secondProductFicheproductLeve1Code+"</a>"
						+ "</div></div></div>";
            		}else{
            			if(p.productFicheFileName !="" && p.productFicheOriginalName !="" && p.productFicheFileName != null && p.productFicheOriginalName !=null && p.productFicheDocId !=null && p.productFicheDocId !=""  ){
            				productFichehtml += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ p.productFicheDocId + "' data-file='" + p.productFicheFileName + "' data-original='" + p.productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+p.productFicheproductLeve1Code+")"+ "'>"
                 			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
                 			+ "</a>";
	                	}
            		}
            	}else{
            		if(p.productFicheFileName !="" && p.productFicheOriginalName !="" && p.productFicheFileName != null && p.productFicheOriginalName !=null && p.productFicheDocId !=null && p.productFicheDocId !=""  ){
        				productFichehtml += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ p.productFicheDocId + "' data-file='" + p.productFicheFileName + "' data-original='" + p.productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+p.productFicheproductLeve1Code+")"+ "'>"
             			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
             			+ "</a>";
                	}
            	}
            	//LGEGMC-3921
            	/*LGEGMC-1035 start*/
				if($('html').attr('data-countrycode') == 'uk'){
					if(p.energyLabel != "" && p.energyLabel != "N" && p.energyLabel != null && p.energyLabelDocId !=null && p.energyLabelDocId !="" && p.energyLabelFileName != null && p.energyLabelFileName != "" && p.energyLabelOriginalName !=null
							&& p.energyLabelOriginalName !="" && p.energyLabelImageAddr !=null && p.energyLabelImageAddr !="" && p.energyLabelName !=null && p.energyLabelName !="" && p.fEnergyLabelFileName!= null && p.fEnergyLabelDocId!= null && p.fEnergyLabelDocId!= ""&&p.fEnergyLabelFileName!='' && p.fEnergyLabelOriginalName !=null&& p.fEnergyLabelOriginalName !=''){
						var energyLabelhtml = "<div class='energy-label-wrap'><a href='#' class='label-link'><span class='label'><img src='"+ p.energyLabelImageAddr +"' alt='"+ p.energyLabelName +"'></span></a>"
						var energyLabelImagehtml = "<div class='tooltip-link'><div class='tolltip-inner'>";
						if(p.fEnergyLabelFileName!= null && p.fEnergyLabelDocId!= null && p.fEnergyLabelDocId!= ""&&p.fEnergyLabelFileName!='' && p.fEnergyLabelOriginalName !=null&& p.fEnergyLabelOriginalName !=''){
							energyLabelImagehtml += "<a href='#' class='link-text link-text-uk' adobe-click='pdp-file-down-click' data-doc='" + p.fEnergyLabelDocId + "' data-file='" + p.fEnergyLabelFileName + "' data-original='" + p.fEnergyLabelOriginalName + "'  data-category='' title='" + pdfDownloadFile +"("+p.fenergyLabelproductLeve1Code+")"+ "'>"+$("#pdfDownloadFileUk").val()+"</a>";
						}
					energyLabelImagehtml += "<a href='#' class='link-text link-text-eu' adobe-click='pdp-file-down-click' data-doc='" + p.energyLabelDocId + "' data-file='" + p.energyLabelFileName + "' data-original='" + p.energyLabelOriginalName + "'  data-category='' title='" + pdfDownloadFile +"("+p.energyLabelproductLeve1Code+")"+ "'>"+$("#pdfDownloadFileEu").val()+"</a></div></div></div>"
					}else{
						var energyLabelhtml = "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + p.energyLabelDocId + "' data-file='" + p.energyLabelFileName + "' data-original='" + p.energyLabelOriginalName + "' class='link-text' data-category='' title='" + pdfDownloadFile +"("+p.energyLabelproductLeve1Code+")"+ "'>"
						+ "<span class='label type-none'>";
						var energyLabelImagehtml = "<img src='"+ p.energyLabelImageAddr +"' alt='"+ p.energyLabelName +"'></span></a>";
					}
				}else{
					var energyLabelhtml = "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + p.energyLabelDocId + "' data-file='" + p.energyLabelFileName + "' data-original='" + p.energyLabelOriginalName + "' class='link-text' data-category='' title='" + pdfDownloadFile +"("+p.energyLabelproductLeve1Code+")"+ "'>"
					+ "<span class='label type-none'>";
					var energyLabelImagehtml = "<img src='"+ p.energyLabelImageAddr +"' alt='"+ p.energyLabelName +"'></span></a>";
				}
				/*LGEGMC-1035 end*/
				//LGEGMC-3921
			if(p.washTowerFlag=="Y"){
				if($('html').attr('data-countrycode') == 'uk'){
					if(p.secondEnergyLabel != "" && p.secondEnergyLabel != "N" && p.secondEnergyLabel != null && p.secondEnergyLabelDocId !=null && p.secondEnergyLabelDocId !="" && p.secondEnergyLabelFileName != null && p.secondEnergyLabelFileName != "" && p.secondEnergyLabelOriginalName !=null
							&& p.secondEnergyLabelOriginalName !="" && p.secondEnergyLabelImageAddr !=null && p.secondEnergyLabelImageAddr !="" && p.secondEnergyLabelName !=null && p.secondEnergyLabelName !="" && p.secondFEnergyLabelFileName!= null && p.secondFEnergyLabelDocId!= null && p.secondFEnergyLabelDocId!= ""&&p.secondFEnergyLabelFileName!='' && p.secondFEnergyLabelOriginalName !=null&& p.secondFEnergyLabelOriginalName !=''){
						var secondEnergyLabelhtml = "<div class='energy-label-wrap'><a href='#' class='label-link'><span class='label'><img src='"+ p.secondEnergyLabelImageAddr +"' alt='"+ p.secondEnergyLabelName +"'></span></a>"
						var secondEnergyLabelImagehtml = "<div class='tooltip-link'><div class='tolltip-inner'>";
						secondEnergyLabelImagehtml += "<a href='#' class='link-text link-text-uk' adobe-click='pdp-file-down-click' data-doc='" + p.secondFEnergyLabelDocId + "' data-file='" + p.secondFEnergyLabelFileName + "' data-original='" + p.secondFEnergyLabelOriginalName + "'  data-category='' title='" + pdfDownloadFile +"("+p.secondFEnergyLabelproductLeve1Code+")"+ "'>"+$("#pdfDownloadFileUk").val()+"</a>";
						secondEnergyLabelImagehtml += "<a href='#' class='link-text link-text-eu' adobe-click='pdp-file-down-click' data-doc='" + p.secondEnergyLabelDocId + "' data-file='" + p.secondEnergyLabelFileName + "' data-original='" + p.secondEnergyLabelOriginalName + "'  data-category='' title='" + pdfDownloadFile +"("+p.secondEnergyLabelproductLeve1Code+")"+ "'>"+$("#pdfDownloadFileEu").val()+"</a></div></div></div>"
					}else{
						var secondEnergyLabelhtml = "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + p.secondEenergyLabelDocId + "' data-file='" + p.secondEnergyLabelFileName + "' data-original='" + p.secondEnergyLabelOriginalName + "' class='link-text' data-category='' title='" + pdfDownloadFile +"("+p.secondEnergyLabelproductLeve1Code+")"+ "'>"
						+ "<span class='label type-none'>";
						var secondEnergyLabelImagehtml = "<img src='"+ p.secondEnergyLabelImageAddr +"' alt='"+ p.secondEnergyLabelName +"'></span></a>";
					}
				}else{
					var secondEnergyLabelhtml = "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + p.secondEenergyLabelDocId + "' data-file='" + p.secondEnergyLabelFileName + "' data-original='" + p.secondEnergyLabelOriginalName + "' class='link-text' data-category='' title='" + pdfDownloadFile +"("+p.secondEnergyLabelproductLeve1Code+")"+ "'>"
					+ "<span class='label type-none'>";
					var secondEnergyLabelImagehtml = "<img src='"+ p.secondEnergyLabelImageAddr +"' alt='"+ p.secondEnergyLabelName +"'></span></a>";
				}
			}	
			//LGEGMC-3921
			//LGEGMC-5315
			if(docTypeCodeFlag == "N" || docTypeCodeFlag == "O"){
				if(p.productFicheFileName !="" && p.productFicheOriginalName !="" && p.productFicheFileName != null && p.productFicheOriginalName !=null && p.productFicheDocId !=null && p.productFicheDocId != ""){
					template = template.replace(/\*productFileName2\*/g,productFichehtml);
					template = template.replace(/\*productFileName\*/g,"");
				} else{
					template = template.replace(/\*productFileName2\*/g,"");
					template = template.replace(/\*productFileName\*/g,"");
				}
			}else{
				if(p.productFicheFileName !="" && p.productFicheOriginalName !="" && p.productFicheFileName != null && p.productFicheOriginalName !=null && p.productFicheDocId !=null && p.productFicheDocId != ""){
					template = template.replace(/\*productFileName\*/g,productFichehtml);
					template = template.replace(/\*productFileName2\*/g,"");
				} else{
					template = template.replace(/\*productFileName\*/g,"");
					template = template.replace(/\*productFileName2\*/g,"");
				}
			}
			//LGEGMC-5315
			if(p.energyLabel != "" && p.energyLabel != "N" && p.energyLabel != null && p.energyLabelDocId !=null && p.energyLabelDocId !="" && p.energyLabelFileName != null && p.energyLabelFileName != "" && p.energyLabelOriginalName !=null
					&& p.energyLabelOriginalName !="" && p.energyLabelImageAddr !=null && p.energyLabelImageAddr !="" && p.energyLabelName !=null && p.energyLabelName !=""){
				template = template.replace(/\*energyLabel\*/g,energyLabelhtml);
				template = template.replace(/\*energyLabelImage\*/g,energyLabelImagehtml);
					ynEnergyLabel = "Y";
			} else{
				template = template.replace(/\*energyLabelImage\*/g, "");
				template = template.replace(/\*energyLabel\*/g,"");
			} 
			
			if(p.secondEnergyLabel != "" && p.secondEnergyLabel != "N" && p.secondEnergyLabel != null && p.secondEnergyLabelDocId !=null && p.secondEnergyLabelDocId !="" && p.secondEnergyLabelFileName != null && p.secondEnergyLabelFileName != "" && p.secondEnergyLabelOriginalName !=null
					&& p.secondEnergyLabelOriginalName !="" && p.secondEnergyLabelImageAddr !=null && p.secondEnergyLabelImageAddr !="" && p.secondEnergyLabelName !=null && p.secondEnergyLabelName !=""){
			template = template.replace(/\*secondEnergyLabel\*/g,secondEnergyLabelhtml);
			template = template.replace(/\*secondEnergyLabelImage\*/g,secondEnergyLabelImagehtml);
				ynEnergyLabel = "Y";
		    } else{
				template = template.replace(/\*secondEnergyLabel\*/g, "");
				template = template.replace(/\*secondEnergyLabelImage\*/g,"");
			}   
				
				if(p.membershipDisplayFlag=="Y"){
					var memberTemplate = filter.memberTemplate;
					memberTemplate = memberTemplate.replace(/\*siblingMembershipPrice\*/g,(nvl(p.rMembershipPrice,'')+'.'+nvl(p.rMembershipPriceCent,'00') || ''));
					if(SIGN_IN_STATUS == 'N' && filter.guestPriceMessageUseFlag == 'Y') memberTemplate = filter.guestPriceMessage;		//	LGCOMPA-44
					template = template.replace(/\*productMembershipMsg\*/g,memberTemplate);
				}else{
					template = template.replace(/\*productMembershipMsg\*/g,'');
				}
				//LGCOMITF-69 START
				if(!!p.obsWelcomePriceUseFlag && p.obsWelcomePriceUseFlag == "Y"){
					var obsWelcomePriceTemplate = filter.obsWelcomePriceTemplate;
					obsWelcomePriceTemplate = obsWelcomePriceTemplate.replace(/\*filterPagingObsWelcomePrice\*/g, changeFormatFullPrice(p.obsWelcomePrice, p.obsWelcomePriceCent));
					obsWelcomePriceTemplate = obsWelcomePriceTemplate.replace(/\*filterPagingObsWelcomePriceDescription\*/g, p.obsWelcomePriceDescription);
					
					template = template.replace(/\*filterPagingObsWelcomePriceArea\*/g, obsWelcomePriceTemplate);
				}else{
					template = template.replace(/\*filterPagingObsWelcomePriceArea\*/g, '');
				}
				//LGCOMITF-69 END
				//LGEFR-640
				var repairabilityArea = $(template).find('.repairability-index');
				var repairabilityMsg = repairabilityArea.attr('data-repairability-msg');
				var targetBlankMsg = repairabilityArea.attr('data-target-blank-msg');
				
				if(p.labelRepairMap.length > 0){	
					var repairMapData = p.labelRepairMap[0];
					
					var repairAbilityHtml  = "<div class='score'>";
					    repairAbilityHtml  += "<span class='txt'>"+repairabilityMsg+"</span>";
					if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
						repairAbilityHtml  += "<a href='"+repairMapData.linkUrl+"'";
						if(repairMapData.linkOpt =='S'){
							repairAbilityHtml  += " target='_self'";
						}else if(repairMapData.linkOpt =='B'){
							repairAbilityHtml  += " target='_blank'";
						}
						repairAbilityHtml  += " title='"+targetBlankMsg+"' class='link-pdf'>";
					}else{
                        repairAbilityHtml  += "<span class='link-pdf'>";
                    }
					if(repairMapData.imagePathAddr != 'null' && repairMapData.imagePathAddr != ''){
						repairAbilityHtml  += "<img src='"+repairMapData.imagePathAddr+"' alt='"+repairMapData.altText+"' area-hidden='true' />";
					}
					if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
						repairAbilityHtml  += "</a></div>";
					}else{
						repairAbilityHtml  += "</span></div>";
                    }
					template = template.replace(/\*repairabilityIndex\*/g, repairAbilityHtml);
				}else{
					template = template.replace(/\*repairabilityIndex\*/g, "");
				}
				//LGEFR-640	
				var $template = $(template),
					$keyBlocks = $template.find('*[data-key]'),
					$loopBlocks = $template.find('*[data-loop]');
				
				//LGEAU-787 START
				if(p.preOrderTagEnableFlag == "Y"){
					$template.find('.tag-content').empty();
				}
				
				//PJTPDR-1, LGEGMC-4343 START
				var pdrCompareUseFlag = p.pdrCompareUseFlag;
				if(pdrCompareUseFlag == 'N'){
					$template.find('a.js-compare').css('display', 'none');
				}
				//PJTPDR-1, LGEGMC-4343 END

				for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
					var $currentKeyBlock = $keyBlocks.eq(i1),
						key = $currentKeyBlock.get(0).getAttribute('data-key'),
						val = p[key];
					if(!val || (val == null || val == "N")) {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.removeClass('active');
						}else {
							$currentKeyBlock.remove();
						}
					}else {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.addClass('active');
						}
					}
					//PJTLIMITQTY_EXTEND ADD 
					//LGEDE-907 Start
					if('Y' == p.obsComTagShowFlag) {
						if('OBS' == p.productTag1Type) {
							if(null != p.productTag1 && '' != p.productTag1) {
								if(key == 'productTag1') $currentKeyBlock.addClass('flag-imp');
							}
						} else if('COM' == p.productTag1Type) {
							if(null != p.productTag1 && '' != p.productTag1) {
								if(key == 'productTag1') $currentKeyBlock.removeClass('flag-imp');
							}
						}
						
						if('OBS' == p.productTag2Type) {
							if(null != p.productTag2 && '' != p.productTag2) {
								if(key == 'productTag2') $currentKeyBlock.addClass('flag-imp');
							}
						} else if('COM' == p.productTag2Type) {
							if(null != p.productTag2 && '' != p.productTag2) {
								if(key == 'productTag2') $currentKeyBlock.removeClass('flag-imp');
							}
						}
						
						if((p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') || p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y"){
							if(p.vipPriceFlag != 'Y' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') {
								$template.find('.price-vip').text(productMessages.limitSaleTitle);
							}
						}
							
					} else { // 기존 로직
						if((p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') || p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y"){
							$keyBlocks.closest('span').addClass('flag-imp');
							if(p.vipPriceFlag != 'Y' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y') {
								$template.find('.price-vip').text(productMessages.limitSaleTitle);
							}
						}
					}
					//LGEDE-907 End
				}

				// in-house reivew rating star - ie fix
				$template.find('.carmine-star').css({
					width: p.reviewRatingPercent+"%"
				});

				// sibling target check
				if(p.target && p.target.toUpperCase() == "SELF") {
					$template.find('.item.js-model').addClass('self');
				}else {
					$template.find('.item.js-model').removeClass('self');
				}

				// price setting
				$priceArea = $template.find('.price-area.total');
				if($priceArea.length!=0) {
					$priceArea.removeClass('type-none type-default type-msrp type-promotion type-text');
					if(p.modelStatusCode=='DISCONTINUED') {
						// do nothing
					} else if(p.retailerPricingFlag == "Y") {
						// type text
						$priceArea.addClass('type-text');
						$priceArea.find('.text').text(p.retailerPricingText);
					// 20200514 START 박지영 : 조건문에서 promotionPrice 제거
					} else if(p.rPromoPrice != null && p.rPrice != null && p.rPromoPrice != '' && p.rPrice != '') {
					// 20200514 END
						// type promotion
						$priceArea.addClass('type-promotion');
						var price = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
						var pricePromo = changeFormatFullPrice(p.rPrice, p.rPriceCent);
						$priceArea.find('.purchase-price .price .number').text(price);
						$priceArea.find('.product-price .price .number').text(pricePromo);
						//LGEDE-1151
						if($priceArea.find('.product-price .price.has-uvp').length>0) {
	                        $priceArea.find('.product-price .price.has-uvp .number').text(pricePromo);                       	
	                    };
	                    //LGEDE-1151
						$priceArea.find('.product-price .legal').html(p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'));		// LGEIS-229 change how discounts are shown
					} else {
						if(p.bizType=="B2B") {
							if(p.rPrice != null && p.rPrice != '') {
								// type b2b
								var price = changeFormatFullPrice(p.rPrice, p.rPriceCent);
								$priceArea.addClass('type-msrp');
								$priceArea.find('.purchase-price .price .number').text(price);
							}
						} else {
							if(p.rPrice != null && p.rPrice != '') {
								// type default
								var price = changeFormatFullPrice(p.rPrice, p.rPriceCent);
								$priceArea.addClass('type-default');
								$priceArea.find('.purchase-price .price .number').text(price);
							}
						}
					}
					// PJTOBS-32 Start
					//if(ISVIP) $priceArea.addClass('vip-price-area'); //PJTOBSEMI-4-num2 search vip-price-area 클래스 삭제
					//PJTLIMITQTY_EXTEND
					var limitSaleConditionFlag =  p.vipPriceFlag == 'N' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y' ? 'Y' : 'N';
					if(p.vipPriceFlag == 'Y') {
						var priceOrg = changeFormatFullPrice(p.rPrice, p.rPriceCent);
						var pricePromo = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
						var legal = p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		// LGEIS-229 change how discounts are shown
						var vipPriceText = productMessages.vipPriceMessage;
						//LGEMS-432 Start
						if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
							vipPriceText = productMessages.b2bVipPriceMessage;
						}
						//LGEMS-432 End
						var previousPriceText = productMessages.previousPriceText;
						var emiMsgText = p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '';

						// LGEPL-697 Start
						setVipPrice($priceArea, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, p.modelId + '/' + 'search-result-filter.js',emiMsgText,p.afterPay, limitSaleConditionFlag, p.limitSaleTitle);
						// LGEPL-697 End
					}
					// PJTOBS-32 End
				}
				
				//LGCOMITF-69 START
				if(!!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag){
					$template.find('.coupon-price').removeClass('d-none');
				}else{
					$template.find('.coupon-price').html('');
				}
				//LGCOMITF-69 END

				if(productType == 'card') {
					// card type
					if(!!p.signatureFlag && p.signatureFlag == "Y") {
						ynBrandTag = "Y";
					} else {
						$template.find('.model-brand-area .brand-signature').remove();
					}
					if(!!p.thinqFlag && p.thinqFlag == "Y") {
						ynBrandTag = "Y";
					} else {
						$template.find('.model-brand-area .brand-thinq').remove();
					}
				}

				// siblingModels
				var $sibling = $template.find('.model-group .inner');
				var siblingTypeclass;
				if(p.siblingType && p.siblingType != null) {
					siblingTypeclass = (p.siblingType.toLowerCase() == "color") ? "color" : "size";
				}else {
					siblingTypeclass = null;
				}
				
				var havSiblingModels = p.siblingModels && p.siblingModels.length > 0;
				if((havSiblingModels && siblingTypeclass != null) && $sibling.get(0)) {
					var siblingItem = $template.find('.model-group .'+siblingTypeclass).clone().html(),
						siblingAriaTxt = $template.find('.model-group .'+siblingTypeclass).clone().attr('aria-label'),
						siblingMarkup = [];

					for (var _j = 0; _j < p.siblingModels.length; _j++) {
						var sbModel = p.siblingModels[_j];
						var item = siblingItem.replace(/\*siblingCode\*/g, sbModel.siblingCode)
											.replace(/\*siblingValue\*/g, sbModel.siblingValue)
											.replace(/\*categoryId\*/g, p.categoryId)
											.replace(/\*subModelId\*/g, sbModel.modelId);
						if(sbModel.modelId != p.modelId) {
							item = item.replace('active', '');
						}else {
							var $item = $(item);
							$item.attr('aria-checked', true);
							item = $item.get(0).outerHTML;
						}
						siblingMarkup += item;
					}
					$sibling.append(siblingMarkup);
					$template.find('.model-group .inner').attr('aria-label', siblingAriaTxt);
				// 20200316 START 박지영 : aria 오류 방지
				} else {
					$sibling.removeAttr('role');
				// 20200316 END
				}

				// rolling image
				if(productType == 'card') p.modelRollingImgList = null; // card type에서는 image rolling 사용하지 않음.
				if(p.modelRollingImgList && p.modelRollingImgList != null) {
					$template.find('.visual img.pc').addClass('js-thumbnail-loop').attr('data-img-list', p.modelRollingImgList);
				}

				// PJTOBS 20200703 Start
				// re stock alert
				var $stockArea = $template.find('.stock-area');
				var limitSaleHtml = 
					'<span class="icon" aria-hidden="true"></span>'
				   +'<span class="text">'+productMessages.limitSaleSoldOutText+'</span>';
				if(((!p.reStockAlertFlag || p.reStockAlertFlag!='Y') || p.limitSaleUseFlag == 'Y')  && $stockArea.length>0) {
					//PJTLIMITQTY_EXTEND
					if(p.limitSaleUseFlag == 'Y' && p.obsLimitSale == 'Y'){
						if(p.obsInventoryFlag == 'Y'){
							$stockArea.removeClass('out-of-stock').empty();
						}else{
							$stockArea.addClass('out-of-stock');
							$stockArea.html(limitSaleHtml);
						}
					}else if(!p.reStockAlertFlag || p.reStockAlertFlag!='Y'){
						$stockArea.removeClass('out-of-stock').empty();
					}
				}else{
					if(p.limitSaleUseFlag == 'Y' && p.obsLimitSale == 'Y'){
						$stockArea.addClass('out-of-stock');
						$stockArea.html(limitSaleHtml);
					}
					else if(!p.reStockAlertFlag || p.reStockAlertFlag!='Y'){
						$stockArea.removeClass('out-of-stock').empty();
					}
				}
				//PJTLIMITQTY_EXTEND
				// PJTOBS 20200703 End

				// buttons
				if(productType == 'card') {
					// card type (아래 정의한 버튼 외에는 PLP에서 사용하지 않음)
					// hidden 클래스가 들어가면 해당 버튼 보이지 않음.
					
					// Get Stock Alert  (bottom area - 미출력시 해당 버튼을 지워야 함)
					if($template.find('a.re-stock-alert').length>0) {
						if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y')) {
							$template.find('a.re-stock-alert').addClass('hidden');
						} else {
							$template.find('a.re-stock-alert').removeClass('hidden');
						}
					}

					// Add to Cart (bottom area - 미출력시 해당 버튼을 지워야 함)
					if(p.addToCartFlag == 'Y') {
						// LGEIN-125, LGEIN-155, LGEVN-80
						if(p.obsBuynowFlag == 'Y'){ // Buy now 버튼 사용하지 않음
							// 통합 OBS
							// var buynow = $('#buynow').val();
							// $template.find('a.add-to-cart').removeClass('hidden').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(buynow).removeAttr('target, title');
							$template.find('a.add-to-cart').addClass('hidden'); 
						} else{
							// 통합 OBS
							$template.find('a.add-to-cart').removeClass('hidden').data('model-id', p.modelId).attr('href', '#').attr('role', 'button').removeAttr('target, title');
						}
					} else if(p.addToCartFlag == 'S') {
						// Standalone OBS
						$template.find('a.add-to-cart').removeClass('hidden').data('model-id', p.modelId).attr('href', '#').attr('role', 'button').removeAttr('target, title');
					} else {
						$template.find('a.add-to-cart').addClass('hidden');
					}

					// Delivery & Installation  (bottom area - 미출력시 해당 버튼을 지워야 함)
					if(p.installationFlag=="Y" && p.installationFlag != null && p.installationFlag != '') {
						$template.find('js-installration').removeClass('hidden');
					} else {
						$template.find('js-installration').addClass('hidden');
					}

					// Book online (bottom area - 미출력시 해당 버튼을 지워야 함)

					// Inquiry to buy (bottom area - 미출력시 해당 버튼을 지워야 함)
					if(p.inquiryToBuyFlag=="Y" && p.inquiryToBuyUrl != null && p.inquiryToBuyUrl != '') {
						$template.find('a.inquiry-to-buy').removeClass('hidden').attr('href', p.inquiryToBuyUrl).text(productMessages.inquiryToBuyBtnNm);
					} else {
						$template.find('a.inquiry-to-buy').addClass('hidden');
					}

					// Where to buy (top area - 미출력시 상위 li를 지워야 함)
					if(p.whereToBuyFlag=="Y" && p.whereToBuyUrl != null && p.whereToBuyUrl != '') {
						// go to pdp page
						$template.find('a.where-to-buy').attr('href', p.whereToBuyUrl).text(productMessages.whereToBuyBtnNm).parent().removeClass('hidden');
						$template.find('a.where-to-buy').parent().removeAttr('target, title');
					} else if(p.wtbExternalLinkUseFlag=="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') {
						// go to external link
						$template.find('a.in-buynow:not(.add-to-cart)').attr('href', p.wtbExternalLinkUrl).text(p.wtbExternalLinkName).attr('data-link-name', 'buy_now').removeAttr('data-sc-item').parent().removeClass('hidden');
						if(p.wtbExternalLinkSelfFlag == 'Y') {
							$template.find('a.in-buynow:not(.add-to-cart)').removeAttr('target, title');
						} else {
							$template.find('a.in-buynow:not(.add-to-cart)').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
						}
					} else {
						$template.find('a.where-to-buy').parent().addClass('hidden');
					}

					// Find a dealer  (top area - 미출력시 상위 li를 지워야 함)
					if(p.findTheDealerFlag=="Y" && p.findTheDealerUrl != null && p.findTheDealerUrl != '') {
						$template.find('a.find-a-dealer').attr('href', p.findTheDealerUrl).text(productMessages.findTheDealerBtnNm).parent().removeClass('hidden');
					} else {
						$template.find('a.find-a-dealer').parent().addClass('hidden');
					}

				} else {
					// default type

					// PJTOBS 20200703 Start
					if($template.find('.button a.re-stock-alert').length>0) {
						if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y')) {
							$template.find('.button a.re-stock-alert').removeClass('active');
						} else {
							$template.find('.button a.re-stock-alert').addClass('active');
						}
					}
					// PJTOBS 20200703 End
					// PJTSEARCH-1 modify
					
				//LGEAU-787 START	
				if(p.obsPreOrderFlag == 'Y'){ //PJTOBS/2020/PJTOBSB2E-6 GILS
					if(p.obsBuynowFlag == 'Y'){
						if(p.preOrderTagEnableFlag == 'Y'){
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(productMessages.customOrderBtnNm).removeAttr('target, title')
							.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);	
						}else {
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(productMessages.preOrderBtnNm).removeAttr('target, title')
							.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);														
						}
					}else {
						if(p.preOrderTagEnableFlag == 'Y'){
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.customOrderBtnNm).attr('role', 'button').removeAttr('target, title')
							.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);
						}else {
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.preOrderBtnNm).attr('role', 'button').removeAttr('target, title')
							.addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate);													
						}
					}
				}else if(p.addToCartFlag!="N") {
						if(p.addToCartFlag == 'Y') { 
							// LGEIN-125, LGEIN-155, LGEVN-80
							var obsBuynowFlag = $('#obsBuynowFlag').val();
							if(obsBuynowFlag == 'Y'){
								var buynow = $('#buynow').val();
								if($template.find('.button a.add-to-cart').is('[data-keyword-search-url]')){
									$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').attr('data-keyword-search-url', p.modelUrlPath).text(buynow).removeAttr('target, title');
								}else{
									$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.modelUrlPath).text(buynow).removeAttr('target, title');
								}
							} else{
								// 통합 OBS
								$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
							}
						} else if(p.addToCartFlag == 'S') {
							// Standalone OBS
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').text(productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
						}
					} else if(p.buyNowFlag=="Y" || p.buyNowFlag=="L") {
						if(p.ecommerceTarget == '_blank') {
							$template.find('.button a.add-to-cart').addClass('active').addClass('in-buynow').data('model-id', p.modelId).attr('href', p.buyNowUrl).text(productMessages.buyNowBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);//LGEGMC-1567
						}else {
							$template.find('.button a.add-to-cart').addClass('active').addClass('in-buynow').data('model-id', p.modelId).attr('href', p.buyNowUrl).text(productMessages.buyNowBtnNm).removeAttr('role').removeAttr('target, title');//LGEGMC-1567
						}
						if($template.find('.button a.add-to-cart').is('[data-keyword-search-url]')){
							$template.find('.button a.add-to-cart').attr('href', '#').attr('data-keyword-search-url', p.modelUrlPath);
						}
					// 20200506 START 박지영 - flag 명 변경
					} else if (p.resellerBtnFlag=="Y") {
					// 20200506 END
						if($template.find('.button a.add-to-cart').is('[data-keyword-search-url]')){
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').attr('data-keyword-search-url', p.resellerLinkUrl).text(productMessages.resellerBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
						}else{
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.resellerLinkUrl).text(productMessages.resellerBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
						}
					} else if (p.productSupportFlag=="Y") {
						if($template.find('.button a.add-to-cart').is('[data-keyword-search-url]')){
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', '#').attr('data-keyword-search-url', p.productSupportUrl).text(productMessages.productSupportBtnNm).removeAttr('role').removeAttr('target, title');
						}else{
							$template.find('.button a.add-to-cart').addClass('active').data('model-id', p.modelId).attr('href', p.productSupportUrl).text(productMessages.productSupportBtnNm).removeAttr('role').removeAttr('target, title');
						}
					} else {
						$template.find('.button a.add-to-cart').removeClass('active');
					}
					// WTB btn
					if(p.whereToBuyFlag=="Y" && p.whereToBuyUrl != null && p.whereToBuyUrl != '') {
						// go to pdp page
						if($template.find('.button a.where-to-buy').is('[data-keyword-search-url]')){
							$template.find('.button a.where-to-buy').addClass('active').attr('href', '#').attr('data-keyword-search-url', p.whereToBuyUrl).text(productMessages.whereToBuyBtnNm);
						}else{
							$template.find('.button a.where-to-buy').addClass('active').attr('href', p.whereToBuyUrl).text(productMessages.whereToBuyBtnNm);
						}
						$template.find('.button a.where-to-buy').removeAttr('target, title');
					// 20200413 START 박지영 - gnb search layer 의 wtb 버튼 스크립트 수정
					} else if(p.wtbExternalLinkUseFlag=="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') {
						// go to external link
						//LGEGMC-2202 START
						if($template.find('.button a.in-buynow').is('[data-keyword-search-url]')){
							$template.find('.button a.in-buynow').addClass('active').attr('href', '#').attr('data-keyword-search-url', p.wtbExternalLinkUrl).text(p.wtbExternalLinkName).attr('data-link-name', 'buy_now').removeAttr('data-sc-item');
						}else{
							$template.find('.button a.in-buynow').addClass('active').attr('href', p.wtbExternalLinkUrl).text(p.wtbExternalLinkName).attr('data-link-name', 'buy_now').removeAttr('data-sc-item');
						}
						if(p.wtbExternalLinkSelfFlag == 'Y') {
							$template.find('.button a.in-buynow').removeAttr('target, title');
						} else {
							$template.find('.button a.in-buynow').attr('target', '_blank').attr('title', productMessages.btnNewLinkTitle);
						}
						//LGEGMC-2202 END
					// 20200413 END
					} else {
						$template.find('.button a.where-to-buy').removeClass('active');
					}
					//LGEGMC-2202 END
				// 20200413 END
				// LGCOMPL-46 Start 
				if(p.obsSubscriptionEnableFlag != null && p.obsSubscriptionEnableFlag == 'Y') {
					$template.find('.button a.subscribe-box').removeClass('d-none');
				}
				// LGCOMPL-46 End
				//LGEEG-154
				if(p.buyNowUnionStoreBtnFlag =="Y"){
					$template.find('.button a.buyNowUnionBtn').addClass('active');
				} else{
					$template.find('.button a.buyNowUnionBtn').removeClass('active');
				}
					// Find a dealer btn
					if(p.findTheDealerFlag=="Y" && p.findTheDealerUrl != null && p.findTheDealerUrl != '') {
						if($template.find('.button a.find-a-dealer').is('[data-keyword-search-url]')){
							$template.find('.button a.find-a-dealer').addClass('active').attr('href', '#').attr('data-keyword-search-url', p.findTheDealerUrl).text(productMessages.findTheDealerBtnNm);
						}else{
							$template.find('.button a.find-a-dealer').addClass('active').attr('href', p.findTheDealerUrl).text(productMessages.findTheDealerBtnNm);
						}
					} else {
						$template.find('.button a.find-a-dealer').removeClass('active');
					}
					// inquiry to buy btn
					if(p.inquiryToBuyFlag=="Y" && p.inquiryToBuyUrl != null && p.inquiryToBuyUrl != '') {
						if($template.find('.button a.inquiry-to-buy').is('[data-keyword-search-url]')){
							$template.find('.button a.inquiry-to-buy').addClass('active').attr('href', '#').attr('data-keyword-search-url', p.inquiryToBuyUrl).text(productMessages.inquiryToBuyBtnNm);
						}else{
							$template.find('.button a.inquiry-to-buy').addClass('active').attr('href', p.inquiryToBuyUrl).text(productMessages.inquiryToBuyBtnNm);
						}
					} else {
						$template.find('.button a.inquiry-to-buy').removeClass('active');
					}
				}
				// PJTSEARCH-1 modify
				// PJTOBSEMI-1-v2 Start
				// PJTLIMITQTY_EXTEND
				if(p.emiMsgAreaYn == 'Y' || p.limitSaleAreaYn == 'Y') {
					$template.find('.price-wt-box').addClass('has-topInfo');
				}
				// PJTOBSEMI-1-v2 End
				
				$template.find('template').remove();
				if(i == 0){ // accessiblity focus item
					$template.addClass('first-item');
				}
				//LGEFR-640
				if(p.repairModelAreaYn != 'Y'){
					$template.find('.repairability-index').remove();
				}
				//LGEFR-640
				
				// LGEVN-819 Start
				switch ($template.find(".tag-content span").length) {
				case 1:
					if(p.productTag1 != null && p.productTag1ColorFlag == "Y"){
						$($template.find(".tag-content span")[0]).addClass("flag-gold");
					}
					if(p.productTag2 != null && p.productTag2ColorFlag == "Y"){
						$($template.find(".tag-content span")[0]).addClass("flag-gold");
					}
					break;
					
				case 2:
					if(p.productTag1 != null && p.productTag1ColorFlag == "Y"){
						$($template.find(".tag-content span")[0]).addClass("flag-gold");
					}
					if(p.productTag2 != null && p.productTag2ColorFlag == "Y"){
						$($template.find(".tag-content span")[1]).addClass("flag-gold");
					}
					break;
					
				default:
					break;
				}
				// LGEVN-819 End
				
				// LGECZ-415, LGECZ-421, LGECOMPL-216 Start
				if(p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice) {
					if( $template.find('.price-wt-box').length ) $template.find('.price-wt-box').addClass('has-lowPrice');
					if( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').removeClass('d-none');
					if( $template.find('.lowest-price').length ) $template.find('.lowest-price').removeClass('d-none');
				} else {
					if( $template.find('.price-wt-box').length ) $template.find('.price-wt-box').removeClass('has-lowPrice');
					if( $template.find('.lowest-price-mark').length ) $template.find('.lowest-price-mark').addClass('d-none');
					if( $template.find('.lowest-price').length ) $template.find('.lowest-price').addClass('d-none');
				}
				// LGECZ-415, LGECZ-421, LGECOMPL-216 End
				
				template = $template.get(0).outerHTML;
				html += template;
			}

			return html;
		},
		loadPLP: function(e, isFirst, target){
			var form = filter.el;
			// var isExpander = $(form).data('focus') == true;
			var url = form.action;
			if(e && e.type == 'submit') e.preventDefault(); // if page change
			else if(form.page) form.page.value = 1; // if filter option change
			//var optionList = $(form).find('.option-list:not(.primary-list), .slider-wrap');
			var optionList = $(form).find('.option-list, .slider-wrap');
			var checkedOption = 0;
			var btnFilter = $(".btn-filter");
			optionList.each(function(){
				if($(this).find(".price-range").length > 0){
					if($(this).find(".min-box input[type=hidden]").val().length || $(this).find(".max-box input[type=hidden]").val().length) {
						checkedOption++;
					}
				}else {
					if($(this).find("[type=checkbox]:checked").length){
						checkedOption++;
					}
				}			
				
				if( checkedOption > 0 ) {
					btnFilter.addClass("active");
					btnFilter.find(".filter-count").html( "("+checkedOption+")");
				} else {
					if(btnFilter.hasClass("active")) {
						$(this).removeClass("active");
					}
					btnFilter.find(".filter-count").html("");
				}
			})
			var param = xssfilter($(form).serialize());

			ajax.call(url, param, 'json', function(d){
				var data;
				if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;
				if(d.status == "success" && data) {
					// reset no-contents area
					if($(filter.result.querySelector('.no-content')).is(':visible')) {
						$(filter.result).children().removeAttr('style');
					}

					data.productList = data.productList && data.productList != null ? data.productList : []; 
					/* LGEUS-11775 : 20190807 add, LGEUS-11780 20190812 add */ 
					if(data.promotionTotalCount != null && filter.el.querySelector('input[type=checkbox][name=promotionsOnly]') != null  && data.promotionTotalCount == 0){
						var promotionsOnlySelector = filter.el.querySelector('input[type=checkbox][name=promotionsOnly]');
						promotionsOnlySelector.setAttribute("disabled",'disabled');
						promotionsOnlySelector.parentNode.classList.add("disabled");
						$(promotionsOnlySelector).siblings('.filter-cnt').text('('+data.promotionTotalCount+')');
					}else if(data.promotionTotalCount != null && filter.el.querySelector('input[type=checkbox][name=promotionsOnly]') != null  && data.promotionTotalCount > 0){
						var promotionsOnlySelector = filter.el.querySelector('input[type=checkbox][name=promotionsOnly]');
						promotionsOnlySelector.removeAttribute("disabled");
						promotionsOnlySelector.parentNode.classList.remove("disabled");
						$(promotionsOnlySelector).siblings('.filter-cnt').text('('+data.promotionTotalCount+')');
					}
					if(data.obsTotalCount != null && filter.el.querySelector('input[type=checkbox][name=obsOnly]') != null  && data.obsTotalCount == 0){
						var obsOnlySelector = filter.el.querySelector('input[type=checkbox][name=obsOnly]');
						obsOnlySelector.setAttribute("disabled",'disabled');
						obsOnlySelector.parentNode.classList.add("disabled");
						$(obsOnlySelector).siblings('.filter-cnt').text('('+data.obsTotalCount+')');
					}else if(data.obsTotalCount != null && filter.el.querySelector('input[type=checkbox][name=obsOnly]') != null  && data.obsTotalCount > 0){
						var obsOnlySelector = filter.el.querySelector('input[type=checkbox][name=obsOnly]');
						obsOnlySelector.removeAttribute("disabled");
						obsOnlySelector.parentNode.classList.remove("disabled");
						$(obsOnlySelector).siblings('.filter-cnt').text('('+data.obsTotalCount+')');
					}
					if(data.bundlesTotalCount != null && filter.el.querySelector('input[type=checkbox][name=bundlesOnly]') != null  && data.bundlesTotalCount == 0){
						var bundlesOnlySelector = filter.el.querySelector('input[type=checkbox][name=bundlesOnly]');
						bundlesOnlySelector.setAttribute("disabled",'disabled');
						bundlesOnlySelector.parentNode.classList.add("disabled");
						$(bundlesOnlySelector).siblings('.filter-cnt').text('('+data.bundlesTotalCount+')');
					}else if(data.bundlesTotalCount != null && filter.el.querySelector('input[type=checkbox][name=bundlesOnly]') != null  && data.bundlesTotalCount > 0){
						var bundlesOnlySelector = filter.el.querySelector('input[type=checkbox][name=bundlesOnly]');
						bundlesOnlySelector.removeAttribute("disabled");
						bundlesOnlySelector.parentNode.classList.remove("disabled");
						$(bundlesOnlySelector).siblings('.filter-cnt').text('('+data.bundlesTotalCount+')');
					}


					if(isFirst) {

						// filter.textMore = $('.result-filter-area').attr('data-text-more');
						// filter.textLess = $('.result-filter-area').attr('data-text-less');
						filter.textOpen = $('.result-filter-area').attr('data-text-open');

						var searchFilterList = data.searchFilterList;
						for(var key in searchFilterList){
							
							var legend = searchFilterList[key].legend,
								filterType = searchFilterList[key].filterType,
								list = searchFilterList[key].list,
								dataValue = searchFilterList[key].dataValue,
								minName = searchFilterList[key].minName,
								maxName = searchFilterList[key].maxName,
								dataMin = searchFilterList[key].dataMin,
								dataMax = searchFilterList[key].dataMax,
								// 20200506 START 박지영 - isDynamic 추가
								filterSubtext = searchFilterList[key].filterSubtext,
								isDynamic = true;
								// 20200506 END

							// 20200506 START 박지영 - isDynamic 추가
							if(list.length>0 && (list[0].name=='country' || list[0].name=='subcategoryid')) {
								isDynamic = false;
							}

							filter.createHtml(key, target, isDynamic, legend,filterType,list,dataValue,minName,maxName,dataMin,dataMax,filterSubtext);
							// 20200506 END
							filter.ui.init();
						}

						// target.closest('.collapse-area').find('.btn-list-toggle').removeClass('expose');
						$(filter.el).find('.etc-box').insertAfter($(filter.el).find('.option-box:last-child'));

						filter.slider.init();
						// bind event for slider after category was selected
						filter.addEventSlider();
					}
					if(data.productList.length > 0) {
						// normal product list & single promotion list
						var html;

						/* LGCOMPA-44 start */
						filter.guestPriceMessage		= '';
						filter.guestPriceMessageUseFlag	= '';
						if(!!d.guestPriceMessageUseFlag && d.guestPriceMessageUseFlag == 'Y' && !!d.guestPriceMessage){
							filter.guestPriceMessage		= d.guestPriceMessage;
							filter.guestPriceMessageUseFlag	= d.guestPriceMessageUseFlag;
						}
						/* LGCOMPA-44 end */
						// make markup
						html = filter.createProductItem(data.productList, d.data[0].productMessages);
						
						if(null != d.data[1] && d.data[1].superCategory.length >0){
							if($('.option-list:first(.primary-list) input[type=checkbox]:checked').length==0 && $('input.cartOnly').is(':checked')){
								$('.option-list:first(.primary-list) input[type=checkbox]').closest('li').siblings().hide();
								for(idx in d.data[1].superCategory){
									$('.option-list:first(.primary-list) input[value='+d.data[1].superCategory[idx].value+']').closest('li').show();
								}
							}else if($('.option-list:first(.primary-list) input[type=checkbox]:checked').length==0 && !$('input.cartOnly').is(':checked')){
								$('.option-list:first(.primary-list) input[type=checkbox]').closest('li').siblings().show();
							}
						}else if($('.option-list:first(.primary-list) input[type=checkbox]:checked').length==0 && !$('input.cartOnly').is(':checked')){
							$('.option-list:first(.primary-list) input[type=checkbox]').closest('li').siblings().show();
						}
						
						var pageInfo = data.pageInfo;
						// if(isExpander) { // mobile append list
						// 	$(filter.result.querySelector('.pagination')).hide();

						// 	$(filter.result.querySelector('.list-box')).append(html);
						// 	bindImgError();
						// 	runBVStaticPLP($('#resultAppendTarget'));
						// 	if(typeof renderListingInlineRatingsRU != 'undefined') renderListingInlineRatingsRU(getProductsNameRU());
						// 	var pageVisible = pageInfo && pageInfo.view == "Y";
						// 	if(pageVisible && pageInfo.page < pageInfo.pageCount) {
						// 		filter.result.querySelector('.expander button').value = pageInfo.page+1;
						// 		$(filter.result.querySelector('.expander')).show();
						// 	}else {
						// 		$(filter.result.querySelector('.expander')).hide();
						// 	}
						// }else {
							// $(filter.result.querySelector('.expander')).hide();
							$(filter.result.querySelector('.list-box')).html(html);
							bindImgError();
							runBVStaticPLP($('#resultAppendTarget'));
							if(typeof renderListingInlineRatingsRU != 'undefined') renderListingInlineRatingsRU(getProductsNameRU());
							/* 20191111 : LGEUS-11779 add */
							if ($('#categoryFilterForm input[type=checkbox]:checked').length == 0 && $('#categoryFilterForm .slider-wrap input[value!=""]').length == 0) {
								// $('.btn-result-show').attr("disabled","disabled");
								// $('.btn-result-show').find('.result-count').html("");
								$(filter.el).find('.etc-box').find('button').prop('disabled', true);
								filter.setCount(filter.countAll);
								// $('.result-info .total2').hide();
								// $('.result-info .total1').show();
								if($('.result-other-contents').length > 0) {
									$('.result-other-contents').show();
									$('.search-result-business-products-wrap, .search-result-products-wrap').removeClass('last-of-type');
								}
							} else {
								// $('.result-info .total2').show();
								// $('.result-info .total1').hide();
								if(data.totalCount) {
									//$('.btn-result-show').removeAttr("disabled").find('.result-count').html("("+data.totalCount+")");
									$(filter.el).find('.etc-box').find('button').prop('disabled', false);
									filter.setCount(data.totalCount);
								}
								if($('.result-other-contents').length > 0) {
									$('.result-other-contents').hide();
									$('.search-result-business-products-wrap, .search-result-products-wrap').addClass('last-of-type');
								}
							}
							/* //20191111 : LGEUS-11779 add */
							// setting pagination
							if(pageInfo && pageInfo.view == "Y") {
								if(filter.result.querySelector('.pagination')){
									var pageMarkup = [];
									for (var pageIdx = pageInfo.loopStart; pageIdx <= pageInfo.loopEnd; pageIdx++) {
										var _pageItem = filter.pageTemplate;
										_pageItem = $(_pageItem).get(0),
										_pageButton = _pageItem.querySelector('button');
                                        $(_pageButton).attr('data-value',pageIdx);
										// _pageButton.value = pageIdx;
										_pageButton.innerHTML = pageIdx;
										if(pageIdx.toString() == pageInfo.page) {
											_pageButton.setAttribute('class', 'active');
											_pageButton.setAttribute('aria-current', 'page');
										}
										if(filter.result.querySelector('.pagination').getAttribute('data-aria-pattern')) {
											var _ariaText = filter.result.querySelector('.pagination').getAttribute('data-aria-pattern').replace(/\#/g, pageIdx);
											_pageButton.setAttribute('aria-label', _ariaText);
										}
										pageMarkup += _pageItem.outerHTML;
									}
									$(filter.result.querySelector('.pagination ul')).html(pageMarkup);

									filter.result.querySelector('.pagination .prev').disabled = !pageInfo.leftPage;
									filter.result.querySelector('.pagination .next').disabled = !pageInfo.rightPage;
									// filter.result.querySelector('.pagination .prev').value = pageInfo.page-1;
									// filter.result.querySelector('.pagination .next').value = pageInfo.page+1;
									$(filter.result.querySelector('.pagination .prev')).attr('data-value', pageInfo.page-1);
									$(filter.result.querySelector('.pagination .next')).attr('data-value', pageInfo.page+1);
									$(filter.result.querySelector('.pagination')).show();
								}else if(filter.result.querySelectorAll('.btn-area').length > 0){
									filter.result.querySelector('.btn-area .prev').disabled = !pageInfo.leftPage;
									filter.result.querySelector('.btn-area .next').disabled = !pageInfo.rightPage;
									$(filter.result.querySelector('.btn-area')).show();
								}

								// if(isMobile && pageInfo.loopStart != pageInfo.loopEnd) {
								// 	$(filter.result).find('.expander').show();
								// 	$(filter.result).find('.pagination').hide();
								// }
							}else {
								$(filter.result.querySelector('.pagination')).hide();
								// .btn-area should not be hidden in compare product page.
								if($('.compare-wrap').length==0) {
									// for plp page
									$(filter.result.querySelector('.btn-area')).hide();
								} else {
									// for compare product
									filter.result.querySelector('.btn-area .prev').disabled = !pageInfo.leftPage;
									filter.result.querySelector('.btn-area .next').disabled = !pageInfo.rightPage;
									$(filter.result.querySelector('.btn-area')).show();
								}
							}

							// 20200506 START 박지영 : activateInput, addAriaDescribedby 위치 변경
							// 20200506 END

						// }

						// 20200506 START 박지영 : activateInput, addAriaDescribedby 위치 변경
						filter.activateInput(data.filterEnableList);
						plp.addAriaDescribedby();
						// 20200506 END

						// PJTQUICKWIN START
						var $objGroup = $('.model-group');
						$objGroup.each(function() {
							cheangStatusModelGroup($(this));
						});
						// PJTQUICKWIN END


						$(form).data('focus', false);
						$(filter.el).trigger('appended');

						if(e && e.type == 'submit') {
							// if event type is page change
							var _focusItem = filter.result.querySelector(".first-item");
							//$(_focusItem).find("a, button").eq(0).focus();
							$(_focusItem).removeClass("first-item");
						}

						//if(typeof runEcorebates !== "undefined") {
						//	if($.isFunction(runEcorebates)) runEcorebates();
						//}

					}else {
						// empty data;
						$(filter.result.querySelector('.no-content')).show()
							.siblings().hide();
						// $('.result-number').text('0');
						$('.btn-result-show').attr("disabled").find('.result-count').html("");
						//LGEUS-11780 20190812 add
						filter.activateInput(data.filterEnableList);
						//LGEUS-11780 20190812 add
					}

					if(thumbnailLoop) $(filter.result).trigger('thumbnailCarousel');
				}

				// clear hidden input
				//if(form.viewAll) {
				//	form.viewAll.value = "";
				//}
				if(form.length) {
					form.length.disabled = false;
				}

				$('body').trigger('initialized-plp');
			}, null, 'body');
		},
		// Clear Filter
		reset: function(e){
			// Filter Element
			var form = filter.el;
			filter.removeEvent();
			
			// Uncheck
			$(form).find('input:checked').removeAttr('checked');
			$(form).find('.slider-wrap input').val('').removeData('index');
			//filter.slider.setSlider();
			
			// First Product List Show
			$(filter.el).find('.option-box').find('li').show();
			$('.cartBox').show();
			// List Fold Button Flag
			if($('.btn-list').hasClass('active')){
				$('.btn-list').trigger('click');
			} else {
				// $(filter.el).find('.option-box').find('li').eq(4).nextAll().hide();
			};

			// Reset button disabled
			//$(filter.btnReset).attr("disabled","true");
			// Reset and Show Results  buttons disabled
			$(filter.el).find('.etc-box').find('button').prop('disabled', true);

			$('.btn-filter').removeClass("active");
			$('.btn-filter').find(".filter-count").html("");

			filter.ui.init();
			
			// More / Less Button Event
			// $('.btn-list-toggle button').removeClass('active');
			// $('.btn-list-toggle button').eq(0).addClass('active');
			// 20200311 START 박지영 : clear all filters 클릭시 5개 이하일때는 more버튼 출력되지 않도록 수정
			// if($('.option-list.primary-list ul li').length>5) {
			// 	$('.btn-list-toggle').addClass('expose');
			// } else {
			// 	$('.btn-list-toggle').removeClass('expose');
			// }
			// 20200311 END

			setTimeout(function() {
				filter.loadPLP();
				filter.addEvent();

				// 탭에 전체 갯수 환원
				filter.setCount(filter.countAll);

			}, 100);
		},
		setCount: function(count) {
			
			$(filter.el).find('.etc-box .result-count').text('('+count+')');
			filter.countObj.text(count);
		},
		removeEvent: function(){
			$('.option-list:not(.primary-list)').closest('.option-box').remove();
			$('.slider-wrap').closest('.option-box').remove();
			$(filter.el).off();
		},
		addEvent: function(){
			$(filter.el).on({
				submit: filter.loadPLP
			});
			$(filter.el).on({
				change: function(event, ui) {
					// adobe
					//LGEGMC-1430 start
					var name = changeTitleFormat($(this).closest('.option-box').find('.title strong').text());
					var val = changeTitleFormat($(this).parent().find('.text').text());
					if(!val || val=="") {
						val = changeTitleFormat($(this).attr('title'));
					}
					if($(this).prop('checked')) {
						if(name && val) {
							adobeTrackEvent('product-list-filter', {filter_name : name+"_"+val, page_event : {filter_apply : true}});
						} else if (val) {
							adobeTrackEvent('product-list-filter', {filter_name : val, page_event : {filter_apply : true}});
						}
					}
					//LGEGMC-1430 end
					if(plp.el.form.viewAll) plp.el.form.viewAll.value = '';
					if($(this).closest('.option-list').hasClass('primary-list')) {
						// super category
						var target = $(this);
						if(target.is(':checked') == true) {
						    if($('input.cartOnly').is(':checked') && $('.option-list:first(.primary-list) input[type=checkbox]:checked').length==0){
						        target.closest('li').siblings().hide();
						        filter.loadPLP(null, false, target);
						        filter.addToCartOnly = true;
						    }else{
						        target.closest('li').siblings().hide();
						        filter.loadPLP(null, true, target);
						        if($('input.cartOnly').is(':checked')){
						            filter.addToCartOnly = true;
						        }else{
						            filter.addToCartOnly = false;
						        }
						        $('.cartBox').hide();
						    }
						    $(filter.btnReset).removeAttr("disabled"); 
						} else {
						    if($('.option-box input[name=addtocartonly]').is(':checked')){
						        filter.addToCartOnly = true;
						    }else{
						        filter.addToCartOnly = false;
						    }
						    filter.removeEvent();
						    target.closest('li').siblings().find('input[type=checkbox]').prop('checked','');
						    filter.ui.init();
						    filter.addEvent();
						    filter.loadPLP();
						    $(filter.btnReset).attr("disabled","true");
						    if(!$('input.cartOnly').is(':checked')){
						    	target.closest('ul').find('li').show();
						    }
						    $('.cartBox').show();
						    if(filter.addToCartOnly && !$('input.cartOnly').is(':checked')  && $('.option-list:first(.primary-list) input[type=checkbox]:checked').length==0){
						        $('input.cartOnly').click();
						    }
						}
						
					} else {
						if(!$('.option-list:not(.primary-list) input[type=checkbox][name=addtocartonly]').is(':checked')){
					        $('input.cartOnly').prop('checked','');
					    }
						filter.loadPLP();
					}
				}
			}, 'input');
			
			$(filter.el).on({
				reset: filter.reset
			});
		},
		addEventSlider: function() {
			$(filter.el).on({
				change: function(event, ui) {
					if(ui && ui.handle) {
						var min= $(this).siblings().find('.min-box input').get(0),
							max = $(this).siblings().find('.max-box input').get(0);

						var inputArray = [min, max],
							idx = ui.handleIndex;

						if(inputArray[idx].value && inputArray[idx].value != inputArray[idx].getAttribute('data-old')) {
							var v = (idx==0) ? ($(this).siblings().find('.min-box span').text().replace(/[^0-9.]/g,'')) : ($(this).siblings().find('.max-box span').text().replace(/[^0-9.]/g,''));
							//adobeTrackEvent('product-list-filter', {filter_name : inputArray[idx].getAttribute('name')+"_"+v, page_event : {filter_apply : true}});
						}
						
						inputArray[idx].setAttribute('data-old', inputArray[idx].value);
					}
					if(plp.el.form.viewAll) plp.el.form.viewAll.value = '';
					filter.loadPLP();
				}
			}, '.slider-range');
		},
		returnBetweenValue : function(obj, startIdx, endIdx){
			var betweenValueArray = [];
			startIdx = startIdx ? startIdx : 0;
			endIdx = endIdx ? endIdx : obj.length;
			for (var i = startIdx; i < endIdx; i++) {
				var values = Object.keys(obj[i]).map(function(j) { return obj[i][j]});
				betweenValueArray.push(values.join(''));
			}
			return betweenValueArray.join(',');
		},
		
		// 20200506 START 박지영 - isDynamic 추가
		createHtml : function(k, target, isDynamic, legend, filterType, list, dataValue, minName, maxName, dataMin, dataMax, filterSubtext) {
		// 20200506 END
			var appendList,
				appendListWrap,
				filter_subtext,
				idx = 0;

			if(list.length==0) return false;

			// json searchFilterList에 filterSubtext 여부
			if(filterSubtext){
				filter_subtext = '<div class="filter-subtext">'+filterSubtext+'</div>'
			} else {
				filter_subtext = '';
			};

			switch (filterType){
				case 'LIST' : 
					for(var key in list){
						var name = list[key].name,
							value = list[key].value,
							text = list[key].text,
							count = list[key].count;

						var listContent = 
							'<li>'
						+	'	<label class="checkbox-box checkbox-sm type-round">'
						+	'		<input type="checkbox" name="'+name+'" value="'+value+'" aria-controls="resultAppendTarget">'
						+	'		<span class="checkbox-btn"></span>'
						+	'		<span class="text">'
						//+	'			<span class="filter-option-name">'+text+'</span><em class="filter-option-count">('+count+')</em>'
						+	'			<span class="filter-option-name">'+text+'</span>'
						+	'		</span>'
						+	'	</label>'
						+	'</li>';
						
						if(appendList != undefined){
							appendList += listContent;
						} else {
							appendList = listContent;
						};
					};
					appendListWrap = 
						'<div class="collapse-area">'
					+		'<div class="option-list">'
					+			'<ul>'
					+			appendList
					+			'</ul>'
					+		'</div>'
					+	'</div>';

				break;
				case 'COLOR' : 
				for(var key in list){
					var name = list[key].name,
						value = list[key].value,
						text = list[key].text,
						className = list[key].class;

						var listContent = 
							'<li>'
						+		'<label class="swatch '+ className + '">'
						+			'<input type="checkbox" name="'+name+'" value="'+value+'" data-colorname="'+text+'" title="'+text+'" aria-controls="resultAppendTarget">'
						+			'<span>'+text+'</span>'
						+		'</label>'
						+	'</li>';

						if(appendList != undefined){
							appendList += listContent;
						} else {
							appendList = listContent;
						};
					}

					appendListWrap = 
						'<div class="collapse-area">'
					+ 		'<div class="option-list swatch-list-box">'
					+			'<ul>'
					+				appendList
					+			'</ul>'
					+		'</div>'
					+	'</div>';
				break;
				case 'SLIDER' : 

				filter.dragbarVal[dataValue] = list;
				
				var dragbarValueArray = filter.returnBetweenValue(list);

				appendListWrap = 
					'<div class="slider-wrap" data-value="'+dataValue+'">'
				+	'	<div class="slider-range" data-min="'+dataMin+'" data-max="'+dataMax+'"></div>'
				+	'	<div class="price-range">'
				+	'		<p class="min-box"><span class="min"></span><input type="hidden" name="'+minName+'"></p>'
				+	'		<p class="max-box"><span class="max"></span><input type="hidden" name="'+maxName+'"></p>'
				+	'	</div>'
				+	'<input type="hidden" name="'+dataValue+'" value="'+dragbarValueArray+'">'
				+	'</div>';

				break;
			};
				
			// Legend
			var title;
			
			title =	'<legend class="sr-only">'+legend+'</legend>'
			+		'<div class="option-box-title">'
			+			'<strong aria-hidden="true">'+legend+'</strong>'
			+			'<button type="button" class="btn-list"><span class="sr-only">'+filter.textOpen+'</span></button>'
			+		'</div>'

			if(!legend){
				// 타이틀이 없으면 비우기
				legend = '';
				title =	''
			}

			// 20200506 START 박지영 - isDynamic 추가
			if(!isDynamic) {
			// 20200506 END
				$('.filter-box').append(
					'<fieldset class="option-box">'
					+		title
					+		appendListWrap
					+		filter_subtext
					+	'</fieldset>'
				);
			} else {
				$('.filter-box').append(
					'<fieldset class="option-box dynamic">'
					+		title
					+		appendListWrap
					+		filter_subtext
					+	'</fieldset>'
				);
			}

			idx++;
			if(filter.addToCartOnly){
				$('.option-box input[name=addtocartonly]').prop('checked',true);
			}
		}
	};
	var plp = {
		el: {
			list: document.getElementById('resultProductList'),
			scrollTarget: document.getElementById('resultAppendTarget'),
			form: document.getElementById('categoryFilterForm')
		},
		init: function(){
			var _this = plp;
			_this.addEvent();
			_this.addAriaDescribedby();

			// PJTQUICKWIN START
			var $objGroup = $('.model-group');
			$objGroup.each(function() {
				cheangStatusModelGroup($(this));
			});
			// PJTQUICKWIN END
		},
		addAriaDescribedby: function(){
			var _this = plp;
			var waNumber = 0;
			$(_this.el.list).find('.list-box .item').each(function() {
				var $target;
				if($(this).find('.model-name a') && !$(this).find('.model-name a').is(':empty')) {
					$target = $(this).find('.model-name a');
				}
				if($target) {
					$target.attr('id', 'wa_search_PLP_'+waNumber);
					$(this).find('a.btn').attr('aria-describedby', 'wa_search_PLP_'+waNumber);
					$(this).find('a.js-compare').attr('aria-describedby', 'wa_search_PLP_'+waNumber).attr('role', 'button');
					waNumber++;
				}
			});
		},
		addEvent: function(){
			var _this = this;
			$(plp.el.list).on({
				click: function(e){
					e.preventDefault();
					var page;
					// if($(e.currentTarget).closest('.expander')[0]) { // lead more button
					// 	page = e.currentTarget.value;
					// 	$(plp.el.form).data('focus', true);
					// }else { // general page button
						page = $(e.currentTarget).is('a') ? e.currentTarget.getAttribute('href') : $(e.currentTarget).attr('data-value');

						var pagePosition = "";
						if($(e.currentTarget).is(".prev")) {
							pagePosition = "L";
						}else if($(e.currentTarget).is(".next")){
							pagePosition = "R";
						}
						plp.el.form.pagePosition.value = pagePosition;

						$('html, body').animate({
							scrollTop: $(plp.el.list).offset().top
						}, 500);
						$(plp.el.form).data('focus', false);
					// }

					if($(e.currentTarget).is('.view-all')) {
						if(plp.el.form.viewAll) plp.el.form.viewAll.value = "Y";
						plp.el.form.length.disabled = true;
						plp.el.form.page.value = 'viewAll';
					}else {
						//if(plp.el.form.viewAll) plp.el.form.viewAll.value = "N";
						plp.el.form.length.disabled = false;
						plp.el.form.page.value = page;
					}
					$(plp.el.form).submit();
				}
			}, '.pagination a, .pagination button, a.view-all');
			
			$('#sortBy').parent().find('.chosen-search-input').on('focus', function() {
				if($(this).closest('.sort-select').is(':hover')) {
					// 마우스 작업 시, -active 클래스를 제거해서 border 안나오게.
					$(this).closest('.sort-select').find('.chosen-container-active').removeClass('chosen-container-active');
				}
			});
			$(plp.el.list).on({
				change: function(e){
					// change 후, border 안나오게 -active 제거
					if($(this).closest('.sort-select').find('.chosen-container-active').length > 0 ) {
						$(this).closest('.sort-select').find('.chosen-container-active').removeClass('chosen-container-active');
					}
					var _this = e.currentTarget;
					var sort = _this.options[_this.selectedIndex].value;
					var sortTxt = changeTitleFormat($(this).find('option').eq(_this.selectedIndex).text());
					plp.el.form.sort.value = sort;
					plp.el.form.page.value = 1;
					//LGEGMC-1430 start
					adobeTrackEvent('product-list-sort', {sort_option : sortTxt, page_event : {product_sort : true}});
					//LGEGMC-1430 end
					$(plp.el.form).submit();
					//$('html, body').animate({
					//	scrollTop: $(plp.el.scrollTarget).offset().top
					//}, 500);
					//adobeTrackEvent('product-list-sort', {sort_option : sortTxt, page_event : {product_sort : true}});
				}
			}, '#sortBy');
		}
	};
	//LGEGMC-712
	function nvl(str, defaultStr){
		var check = str+"";
		var result = "";
		check = check.trim()
		if(check=="" || check==null || check == "null" || check=="undefined"){
			result = defaultStr;
		}else{
			result = check;
		}
		return result ;
	}

	plp.init();
	filter.init();	
	
});